import { type Components, type Theme } from "@mui/material/styles";

export const button: Components<Theme>["MuiButton"] = {
  defaultProps: {
    size: "small",
  },
  styleOverrides: {
    root: {
      textTransform: "none",
    },
    sizeMedium: ({ theme }) => ({
      fontSize: theme.typography.pxToRem(14),
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: theme.typography.pxToRem(24),
      letterSpacing: "0.4px",
    }),
    sizeSmall: ({ theme }) => ({
      fontSize: theme.typography.pxToRem(13),
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: theme.typography.pxToRem(22),
      letterSpacing: "0.46px",
    }),
    sizeLarge: () => ({
      display: "flex",
      padding: "8px 22px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "6px",
      fontWeight: 700,
    }),
    containedPrimary: ({ theme }) => ({
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    }),
    textPrimary: ({ theme }) => ({
      color: theme.palette.primary.main,
      backgroundColor: "transparent",
      transition: "none",
      padding: "8px 22px",
      "&:hover": {
        backgroundColor: theme.palette.primary._states.hover,
      },
    }),
    outlinedPrimary: ({ theme }) => ({
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.primary.main}`,
      "&:hover": {
        backgroundColor: theme.palette.primary._states!.hover,
        borderColor: theme.palette.primary.main,
      },
      "&:active": {
        backgroundColor: theme.palette.primary._states!.selected,
        borderColor: theme.palette.primary.main,
      },
    }),
  },
};
